// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1Xxr2","buttons":"RemoveExpirationActionButtons_buttons__74P9-"};